export default __webpack_public_path__ + "static/media/146.f82c687d.png";